export default __webpack_public_path__ + "static/media/notificationSmWhite.edad81a2.svg";